import { app } from "electron";
import { join } from "path";

let folderName: string = "Electron";

export const setAppDataFolderName = (newFolderName: string) => {
	folderName = newFolderName;
};

export const appDataFolderName = () => folderName;

export const appDataFolderPath = () => join(app.getPath("appData"), folderName);

export const appDataLogsPath = () => join(appDataFolderPath(), "/logs");

export const appDataReleasesPath = () => join(appDataFolderPath(), "/e2o/releases");

export const appDataCachePath = () => join(appDataFolderPath(), "/e2o/cache");

export const appDataPreloadsPath = () => join(appDataFolderPath(), "/e2o/cache/preloads");

export const appDataAssetsPath = () => join(appDataFolderPath(), "/e2o/cache/assets");

export const appDataIconsPath = () => join(appDataFolderPath(), "/e2o/cache/icons");
